import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import CustomSearchBar from "components/CustomSearchBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRotateLeft,
  faEye,
  faEdit,
  faTable,
  faMapMarkedAlt,
} from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import CrmInsuranceAssignToEmployee from "features/CrmDashboardComp/CrmInsuranceAssignToEmployee";
import CrmAudioDetails from "features/CrmDashboardComp/CrmAudioDetails";
import { selectCurrentUser } from "features/auth/authSlice";
import { Tag } from "antd";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import {
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
} from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import {
  CheckCircleOutlined,
  FileTextOutlined,
  WarningOutlined,
} from "@ant-design/icons";
// import {
//   useGetBankingLeadsByIdQuery,
//   useAddBankingApplicationMutation,
// } from "features/banking/BankingApiSlice";
import { useGetCrmInsuranceLeadsQuery } from "features/Insurance/InsuranceApiSlice";

import {
  useUploadLeadsMutation,
  useDeleteLeadByIdMutation,
} from "features/CrmDashboardComp/CmrApiSlice";
import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
  useGetBlockByDistrictQuery,
} from "services/locationApiSlice";

import CattleInsurance from "./CattleInsurance";
import Select from "react-select";
import * as XLSX from "xlsx";
import InsuranceAssignDr from "./InsuranceAssignDr";
import InsuranceAssignAgency from "./InsuranceAssignAgency";
import { InsuranceDetailViewModal } from "./InsuranceDetailViewModal";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InsurancePolicyIssue from "./InsurancePolicyIssue";
import { InsuranceTaskDownload } from "./InsuranceTaskDownload";
import CrmAddLead from "features/CrmDashboardComp/CrmAddLead";
import CrmEditLead from "./CrmEditLead";
import { store } from "app/store";
import { API_URL } from "app/config";
import InsuranceVerification from "./InsuranceVerification";
import axios from "axios";

const CrmInsurance = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [searchKey, setSearchKey] = useState("");
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [statusName, setStatusName] = useState("");
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !stateId,
  });
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId, {
    skip: !districtId,
  });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(false);
  const [deleteLead] = useDeleteLeadByIdMutation();
  const [users, setUsers] = useState([]);
  const [BankingApplicationId, setBankingApplicationId] = useState(null);
  const [showWidth, setWidth] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    perPage: 100,
  });
  const [cattleData, setCattleData] = useState([]);
  const [editOpen, EditingIsOpen] = useState(false);

  const [getDataId, setLeadId] = useState();
  const [selectedProduct, setSelectedLabel] = useState("Cattle");
  const RoleAcessParams = currentUser.groups;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [assignAgency, setAssignAgency] = useState(false);
  const [assignDr, setAssignDr] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [dropdownOpenUpload, setDropdownOpenUpload] = useState(false);
  const [policyAssignModal, setPolicyModal] = useState(false);
  const toggleDropdownUpload = () => setDropdownOpenUpload(!dropdownOpenUpload);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // const [dropdownSample, setdropdownSample] = useState(false);
  // const toggleDropdownSample = () => setdropdownSample(!dropdownSample);
  const queryParameters = {
    page: pagination.page,
    perPage: pagination.perPage,
    searchKey: debouncedSearch ? debouncedSearch : "",
    selectedProduct: selectedProduct === "ALL" ? "" : selectedProduct,
    stateCode: stateId,
    districtCode: districtId,
    blockCode: blockId,
    statusName: statusName,
    // statusName:RoleAcessParams.groups.includes("INSURER")?"KYC Verified":""
  };
  const { data, isLoading, isFetching, refetch } = useGetCrmInsuranceLeadsQuery(
    queryParameters
  );
  const [LeadsDataHalf, setLeadsDataHalf] = useState("");
  const [showLeadModal, setOpenLeadModal] = useState(false);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [serviceDetails, setServiceDetails] = useState({});
  const [deleteModel, setDeleteModel] = useState(false);
  const [deleteModelSpinner, setDeleteModelSpinner] = useState(false);
  const handleChange = (event, newValue) => {
    setSelectedLabel(event.target.value);
  };
  const [loading, setLoading] = useState(false);
  const [editModel, setLeadEditModal] = useState(false);
  const [audioModalOpen, setAudioModalOpen] = useState(false);
  const [deleteLeadData, setDeleteLeadData] = useState("");
  const [assignEmployeeModal, setAssignEmployeeModal] = useState(false);
  const [details, setDetailsModal] = useState(false);
  const [leadDataEdit, setLeadDataEdit] = useState({
    first_name: "",
    last_name: "",
    lead_source: "",
    primary_occupation: "",
    email: "",
    phone_number: "",
    DOB: "",
    gender: "",
    service_name: "Insurance",
    product_name: "",
    pincode: "",
    current_remarks: "",
    current_status: "",
    type: "",
  });
  const [showDownload, setDownloadLoading] = useState(false);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      height: "38px",
      borderRadius: "8px",
      fontSize: "13px",
      padding: "0 2px",
      // borderColor: state.isFocused ? "#e9630e" : "#d1d5db",
      // boxShadow: state.isFocused ? "0 0 0 1px #e9630e" : "none",
      transition: "all 0.2s ease",
      // "&:hover": {
      //   borderColor: "#e9630e",
      // },
      // backgroundColor: "#fff",
      alignItems: "center",
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
      height: "38px",
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      height: "auto",
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "6px",
      // color: state.isFocused ? "#e9630e" : "#6b7280",
      transition: "color 0.2s ease",
      // "&:hover": {
      //   color: "#e9630e",
      // },
    }),

    clearIndicator: (provided) => ({
      ...provided,
      padding: "6px",
      color: "#9ca3af",
      // "&:hover": {
      //   color: "#e9630e",
      // },
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      marginTop: 4,
      // boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      fontSize: "13px",
      zIndex: 5,
    }),

    option: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      padding: "8px 10px",
      // backgroundColor: state.isFocused
      //   ? "rgba(233, 99, 14, 0.08)"
      //   : state.isSelected
      //   ? "#e9630e"
      //   : "#fff",
      // color: state.isSelected ? "#fff" : "#111827",
      cursor: "pointer",
      // transition: "background-color 0.2s ease",
      // "&:active": {
      //   backgroundColor: "rgba(233, 99, 14, 0.12)",
      // },
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#9ca3af",
      marginLeft: 2,
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
      marginLeft: 2,
      lineHeight: "1",
    }),
  };

  const [templateDownload, setTemplateDownload] = useState(false);
  useEffect(() => {
    const dataFromApi = data?.data ? data?.data?.results : [];
    const currentPage = data?.data?.current_page || pagination.page;
    const totalPages = data?.data?.pages || pagination.pageCount;
    const perPageFromApi = data?.data?.per_page || pagination.perPage;
    setUsers(dataFromApi);
    setPagination((prev) => {
      if (
        prev.page !== currentPage ||
        prev.pageCount !== totalPages ||
        prev.perPage !== perPageFromApi
      ) {
        return {
          page: currentPage,
          pageCount: totalPages,
          perPage: perPageFromApi,
        };
      }
      return prev;
    });

    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [data, getStates]);
  const refetchLeadsData = async (id) => {
    const state = store.getState();
    setLoading(true);
    try {
      const getLeadsData = await axios.get(
        `${API_URL}/api/v1/crm/leads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (getLeadsData?.data) {
        setLeadsDataHalf(getLeadsData?.data?.data);
        setLoading(false);
        let finalDataBanking = getLeadsData?.data?.data?.lead_details?.find(
          (item) => item.service_name === "Insurance"
        );
        setServiceDetails(finalDataBanking?.service_details);
      }
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  const CustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <svg height="100" viewBox="0 0 184 152" focusable="false">
          <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
              <ellipse
                className="ant-empty-img-5"
                cx="67.797"
                cy="106.89"
                rx="67.797"
                ry="12.668"
              />
              <path
                className="ant-empty-img-1"
                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
              />
              <path
                className="ant-empty-img-2"
                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
              />
              <path
                className="ant-empty-img-3"
                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
              />
            </g>
            <path
              className="ant-empty-img-3"
              d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
            />
            <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
              <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
              <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
            </g>
          </g>
        </svg>
        <Box sx={{ mt: 1 }}>No Records to Display</Box>
      </StyledGridOverlay>
    );
  };

  const handlePerPageRecords = (e) => {
    setPagination({ ...pagination, ...{ perPage: e.target.value } });
  };

  const CustomPagination = () => {
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <select
          name="pages"
          value={pagination.perPage}
          onChange={handlePerPageRecords}
          style={{ padding: "4px 8px", borderRadius: "7px" }}
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <Pagination
          color="primary"
          count={pagination?.pageCount}
          page={pagination?.page}
          onChange={(event, value) => {
            setPagination({
              ...pagination,
              page: value,
            });
            setWidth(false);
          }}
          variant="outlined"
          shape="rounded"
        />
      </Box>
    );
  };

  const handleModalOpen = (item) => {
    setDetailsModal(true);
    setLeadId(item.id);
    refetchLeadsData(item.id);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 70,
      renderCell: (cellValues) => {
        return (
          <div>
            {/* <FontAwesomeIcon
              icon={faTrash}
              className={
                RoleAcessParams.includes("developer")
                  ? "deleteactive"
                  : "not-active"
              }
              style={{ color: "orange", fontSize: "12px", cursor: "pointer",textAlign:"center",marginLeft:"10px" }}
              onClick={() => RemoveLead(cellValues)}
            /> */}
            <FontAwesomeIcon
              icon={faEye}
              style={{
                color: "orange",
                fontSize: "12px",
                cursor: "pointer",
                textAlign: "center",
                marginLeft: "10px",
              }}
              onClick={() => handleModalOpen(cellValues.row)}
            />
            {/* {!cellValues?.row?.status_list?.includes("Policy Issued") &&
              !cellValues?.row?.status_list?.includes("Policy Rejected") &&
              selectedProduct === "Cattle" && (
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    textAlign: "center",
                    marginLeft: "10px",
                  }}
                  className="text-success mx-3"
                  onClick={() => {
                    handleEditLeads(cellValues?.row);
                    setLeadId(cellValues?.row?.id);
                  }}
                />
              )} */}
          </div>
        );
      },
    },
    { field: "full_name", headerName: "Name", width: 180 },
    {
      field: "created_at",
      headerName: "Created At",
      width: 100,
      renderCell: (cellValues) => {
        const dateTime = cellValues?.row?.created_at || "";
        const formattedDate = dateTime.slice(0, 10);
        const formattedTime = dateTime.slice(11, 19);
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                {formattedDate}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#888",
                }}
              >
                &nbsp;{formattedTime}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "phone_number",
      headerName: "Phone No.",
      width: 150,
      renderCell: (cellValues) => {
        const phoneNumber = cellValues?.row?.phone_number || "";
        const dob = cellValues?.row?.DOB;

        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#555",
                  fontWeight: "500",
                }}
              >
                &nbsp; {phoneNumber}
              </div>
            </div>
          </div>
        );
      },
    },

    { field: "lead_source", headerName: "Lead Source", width: 150 },
    {
      field: "current_status",
      headerName: "Current Status",
      width: 240,
      renderCell: (cellValues) => {
        const status = cellValues.row.current_status;
        const statusConfig = {
          "Lead Details Modified": {
            color: "blue",
            icon: <FileTextOutlined />,
          },
          Assigned: { color: "gold", icon: <CheckCircleOutlined /> },
          "Can Not Process": { color: "error", icon: <WarningOutlined /> },
          "Policy Rejected": { color: "error", icon: <WarningOutlined /> },

          "Lead Generated": { color: "volcano", icon: <FileTextOutlined /> },
        };

        const { color, icon } = statusConfig[status] || {
          color: "geekblue",
          icon: <FileTextOutlined />,
        };

        return (
          <Tag
            bordered={false}
            color={color}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "3px 9px",
              fontSize: "13px",
              fontWeight: "500",
              borderRadius: "6px",
            }}
          >
            {icon}
            <span>{status}</span>
          </Tag>
        );
      },
    },

    {
      field: "state_name",
      headerName: "Address",
      width: 220,
      renderCell: (cellValues) => {
        const fullAddress = `${cellValues?.row?.address || ""}`;
        const truncatedAddress =
          fullAddress?.length > 50
            ? `${fullAddress.substring(0, 60)}...`
            : fullAddress;

        return (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "220px",
              fontSize: "12px",
            }}
            title={fullAddress}
          >
            {truncatedAddress}
          </div>
        );
      },
    },

    { field: "primary_occupation", headerName: "Occupation", width: 140 },

    {
      field: "time",
      hideable: true,
      headerName: "Product",
      width: 100,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                color: "steelblue",
              }}
            >
              {cellValues?.row?.lead_details[0]?.service_details?.product_name}
            </div>
          </div>
        );
      },
    },
    {
      field: "count",
      headerName: "Policy Status Count",
      width: 220,
      renderCell: (cellValues) => {
        const cattleData =
          cellValues?.row?.lead_details[0]?.service_details?.cattle_data || [];

        const policyDetails =
          cellValues?.row?.lead_details[0]?.service_details?.policy_details;

        const currentStatus = cellValues?.row?.current_status;

        const badgeStyle = (bgColor, textColor) => ({
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: "12px",
          padding: "2px 8px",
          fontSize: "10px",
          fontWeight: 500,
          display: "inline-block",
          minWidth: "50px",
          textAlign: "center",
        });

        if (policyDetails && currentStatus) {
          if (currentStatus === "Policy Issued") {
            return (
              <span style={badgeStyle("#F6FFED", "#389E0D")}>
                Issued: {cattleData.length}
              </span>
            );
          }
          if (currentStatus === "Policy Rejected") {
            return (
              <span style={badgeStyle("#FFF2F0", "#CF1322")}>
                Rejected: {cattleData.length}
              </span>
            );
          }
        }

        // Otherwise, count per cattle logic
        let issued = 0;
        let rejected = 0;
        let pending = 0;

        cattleData.forEach((cattle) => {
          const policy = cattle.policy_details;
          if (policy) {
            if (policy.policy_issued) issued += 1;
            else rejected += 1;
          } else {
            pending += 1;
          }
        });

        return (
          <div
            style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}
            className="mt-1"
          >
            {issued > 0 && (
              <span style={badgeStyle("#F6FFED", "#389E0D")}>
                Issued: {issued}
              </span>
            )}
            {rejected > 0 && (
              <span style={badgeStyle("#FFF2F0", "#CF1322")}>
                Rejected: {rejected}
              </span>
            )}
            {pending > 0 && (
              <span style={badgeStyle("#FFF7E6", "#D46B08")}>
                Pending: {pending}
              </span>
            )}
          </div>
        );
      },
    },

    {
      field: "assigned_emp_name",
      hideable: true,
      headerName: "Assigned Employee",
      width: 150,
    },
  ];
  const filteredColumns = columns.filter(
    (column) => selectedProduct === "ALL" || column.field !== "time"
  );

  const addLeadModal = () => {
    setOpenLeadModal(true);
  };
  const [Isproposal, setIsProposal] = useState(false);

  const hideLeadEditModal = () => {
    EditingIsOpen(false);
    setCattleData([]);
    setIsProposal(false);
  };
  const hideLeadModal = () => {
    setOpenLeadModal(false);
  };

  const handleEditLeads = (leadsdata) => {
    let finalDataInsurance = leadsdata?.lead_details?.find(
      (item) => item.service_name === "Insurance"
    );
    EditingIsOpen(true);
    setLeadDataEdit({
      first_name: leadsdata.first_name,
      last_name: leadsdata.last_name,
      lead_source: leadsdata.lead_source,
      primary_occupation: leadsdata.primary_occupation,
      email: leadsdata.email,
      phone_number: leadsdata.phone_number,
      DOB: leadsdata.DOB.split("-")
        .reverse()
        .join("-"),
      gender: leadsdata.gender,
      service_name: "Insurance",
      product_name: finalDataInsurance?.service_details?.product_name,
      pincode: leadsdata.pincode,
      current_remarks: leadsdata.current_remarks,
      current_status: leadsdata.current_status,
      type: leadsdata.type,
      address: leadsdata.address,
      allData: leadsdata,
    });
  };

  const handleAssignEmployeeModal = (val) => {
    setAssignEmployeeModal(val);
  };
  const handleCloseAssignEmployeeModal = () => {
    setAssignEmployeeModal(false);
  };
  const closeaudioModal = () => {
    setAudioModalOpen(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };
  const ReloadApplication = () => {
    setLoadingLeads(true);
    setTimeout(() => {
      refetch();
      setLoadingLeads(false);
    }, 2000);
  };
  const ReloadApplication2 = () => {
    refetchLeadsData(getDataId);
  };

  const handleCloseDelete = () => {
    setDeleteModel(false);
    setWidth(false);
  };

  useEffect(() => {
    setWidth(false);
  }, [deleteModel]);
  const SubmitdeleteLead = () => {
    setWidth(false);
    setDeleteModelSpinner(true);
    deleteLead({ id: deleteLeadData.id })
      .unwrap()
      .then((data) => {
        swal("Deleted", {
          buttons: false,
          icon: "success",
          title: "Successfully Deleted",
          timer: 1500,
        });
        setDeleteModel(false);
        refetch();
        setLeadsDataHalf([]);
        setDeleteModelSpinner(false);
      })
      .catch((e) => {
        swal("!!", {
          buttons: false,
          icon: "warning",
          title: "Something Went wrong",
          timer: 3000,
        });
      });
  };
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);
  const handleStatusChange = (selectedOption) => {
    if (selectedOption) {
      setStatusName(selectedOption.value);
    } else {
      setStatusName("");
    }
  };
  const downloadExcel = async () => {
    setDownloadLoading(true);
    try {
      const queryParameters = {
        page: 1,
        per_page: 1000,
        searchKey:
          debouncedSearch || (RoleAcessParams?.includes("INSURER") ? "" : ""),
        product_name: selectedProduct,
        stateCode: stateId,
        districtCode: districtId,
        blockCode: blockId,
        statusName: statusName,
        statusIncludes: "",
      };
      const params = new URLSearchParams(queryParameters).toString();
      const state = store.getState();
      const url = `${API_URL}/api/v1/crm/insurance/leads?${params}`;
      const response = await fetch(url, {
        headers: {
          authorization: `Bearer ${state.auth.accessToken}`,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }
      const farmers = await response.json();
      const headers = [
        "Name",
        "Created At",
        "Phone Number",
        "Lead Source",
        "Application Status",
        "Address",
        "Occupation",
        "Assigned Employee",
      ];
      const rows = farmers?.data?.results?.map((user) => {
        const baseRow = {
          Name: user.full_name || "",
          "Created At": user.created_at
            ? new Date(user.created_at).toLocaleString()
            : "",
          "Phone Number": user.phone_number || "",
          "Lead Source": user.lead_source || "",
          "Application Status": user.current_status || "",
          Address: user.address || "",
          Occupation: user.primary_occupation || "",
          "Assigned Employee": user.assigned_emp_name || "",
          "Service Type": user.lead_details?.[0]?.service_name || "",
        };
        return baseRow;
      });
      const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
      XLSX.writeFile(workbook, "LeadsData.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error.message);
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleAssignAgency = (val) => {
    setAssignAgency(val);
  };
  const handleCloseAssignModal = () => {
    setAssignAgency(false);
  };
  const [activeTab, setActiveTab] = useState("table");

  return (
    <div>
      <div className="row mt-3">
        <div className={showWidth ? "col-md-4" : "col-md-12"}>
          <Card>
            <div className="d-flex justify-content-between align-items-center p-1 mt-2 mb-2">
              <div className="d-flex justify-content-between align-items-center p-2 mt-2">
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CustomSearchBar sendSearchFunction={handleChangeSearch} />
                  <span className="fw-semibold text-success mx-4">
                    Total Leads: {data?.data?.total || 0}
                  </span>
                </div>
              </div>

              <FormControl
                component="fieldset"
                className="d-flex mx-3"
                style={{
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                
                <RadioGroup
                  row
                  aria-label="business-type"
                  name="business-type"
                  value={selectedProduct}
                  onChange={handleChange}
                  style={{
                    display: "flex",
                    gap: "20px",
                  }}
                >
                  {["Cattle","Crop", "Motor", "Health", "ALL"].map(
                    (option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={
                          <Radio
                            sx={{
                              "&.Mui-checked": {
                                color: "orange",
                              },
                              "&:hover": {
                                backgroundColor: "rgba(255, 165, 0, 0.1)",
                              },
                              transform: "scale(0.8)",
                              width: 14,
                              height: 14,
                              marginRight: "10px",
                            }}
                          />
                        }
                        label={option}
                        style={{
                          color: selectedProduct === option ? "orange" : "gray",
                          fontWeight:
                            selectedProduct === option ? "bold" : "normal",
                          fontSize: "10px",
                        }}
                      />
                    )
                  )}
                </RadioGroup>
              </FormControl>
            </div>

            {/* <CardHeader style={{marginTop:"-10px"}}>
              <div className="d-flex justify-content-end align-items-start gap-2">
                <Button
                  id="AddLeads"
                  className="buttonOrangeDefaultColor  float-end"
                  size="sm"
                  onClick={addLeadModal}
                >
                  Add Lead &nbsp;
                  <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                </Button>

                {showWidth == false ? (
                  <>
                    {RoleAcessParams.includes("CRM User") ? (
                      ""
                    ) : (
                      <Button
                        id="AddLeads"
                        className="buttonOrangeDefaultColor2 float-end"
                        onClick={() => handleAssignEmployeeModal(true)}
                        size="sm"
                      >
                        Assign To Employee &nbsp;
                        <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                      </Button>
                    )}
                  </>
                ) : (
                  ""
                )}
                <Button
                  className="bg-transparent text-black"
                  style={{
                    border: "1px solid #829999",
                    color: "#343737",
                    marginTop: "0",
                  }}
                  size="sm"
                  onClick={ReloadApplication}
                >
                  Reload&nbsp;
                  <FontAwesomeIcon icon={faRotateLeft} />
                </Button>
              </div>
            </CardHeader> */}
            <CardHeader style={{ marginTop: "-10px" }}>
              <Row className="align-items-center mx-2 mt-2">
                <Col lg="7" className="d-flex gap-2 ">
                  <Col sm="3" className="mb-2 position-relative">
                    <Select
                      menuPlacement="auto"
                      options={handleStateOptions()}
                      placeholder={stateId === "" ? "State" : stateName}
                      value={
                        stateId === ""
                          ? null
                          : { value: stateId, label: stateName }
                      }
                      onChange={onLocationChange}
                      styles={customStyles}
                      isLoading={loadingStateOptions}
                    />
                    {stateId && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          setStateId("");
                          setStateName("");
                        }}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "40px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "gray",
                          fontSize: "12px",
                          zIndex: 1000,
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </Col>

                  <Col sm="3" className="mb-2 position-relative">
                    <Select
                      menuPlacement="auto"
                      options={handleDistrictOptions()}
                      placeholder={
                        districtName === "" ? "District" : districtName
                      }
                      value={
                        districtName === ""
                          ? null
                          : { value: districtId, label: districtName }
                      }
                      onChange={onLocationChange}
                      styles={customStyles}
                      isLoading={loadingDistrictOptions}
                    />
                    {districtName && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          setDistrictId("");
                          setDistrictName("");
                        }}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "40px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "gray",
                          fontSize: "12px",
                          zIndex: 1000,
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </Col>

                  <Col sm="3" className="mb-2 position-relative">
                    <Select
                      menuPlacement="auto"
                      options={[
                        { value: "Lead Generated", label: "Lead Generated" },

                        {
                          value: "Assigned For Inspection",
                          label: "Assigned For Inspection",
                        },
                        {
                          value: "Proposal Form Submitted",
                          label: "Proposal Form Submitted",
                        },
                        {
                          value: "Payment Submitted",
                          label: "Payment Submitted",
                        },

                        { value: "Policy Issued", label: "Policy Issued" },
                        {
                          value: "Policy Rejected",
                          label: "Policy Rejected",
                        },
                      ]}
                      placeholder="Status"
                      value={
                        statusName
                          ? { value: statusName, label: statusName }
                          : null
                      }
                      onChange={handleStatusChange}
                      styles={customStyles}
                    />
                    {statusName && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          setStatusName("");
                        }}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "40px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "gray",
                          fontSize: "12px",
                          zIndex: 1000,
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </Col>
                </Col>

                <Col lg="5" className="d-flex justify-content-end gap-2">
                  <Button
                    id="AddLeads"
                    className="buttonOrangeDefaultColor"
                    size="sm"
                    onClick={addLeadModal}
                  >
                    Add Lead&nbsp;
                    <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                  </Button>

                  {RoleAcessParams.includes("CRM User") ||
                  RoleAcessParams.includes("CRM Admin") ? (
                    ""
                  ) : (
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                      <DropdownToggle
                        caret
                        className="buttonOrangeDefaultColor2"
                        size="sm"
                      >
                        Assign&nbsp;
                        <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => handleAssignEmployeeModal(true)}
                          className="dropdown-hover-item"
                        >
                          Assign Employees
                        </DropdownItem>
                        {/* <DropdownItem
                          onClick={() => handleAssignAgency(true)}
                          className="dropdown-hover-item"
                        >
                          Assign Leads to Agency
                        </DropdownItem> */}
                        <DropdownItem
                          onClick={() => setAssignDr(true)}
                          className="dropdown-hover-item"
                        >
                          Assign To Agent
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => handleAssignAgency(true)}
                          className="dropdown-hover-item"
                        >
                          Update Status
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => setPolicyModal(true)}
                          className="dropdown-hover-item"
                        >
                          Policy Issue/Reject
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}

                  {/* {RoleAcessParams.includes("CRM Admin") && (
                    <>
                      <Button
                        id="AddLeads"
                        className="buttonOrangeDefaultColor2"
                        onClick={(e) => UploadBulkModal(true)}
                        size="sm"
                      >
                        Upload Leads&nbsp;
                        <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                      </Button> */}
                  {/* <Button
                    id="AddLeads"
                    className="buttonOrangeDefaultColor2"
                    onClick={(e) => UploadBulkModal(true)}
                    size="sm"
                  >
                    Upload&nbsp;
                    <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                  </Button> */}
                  {/* <Dropdown
                    isOpen={dropdownSample}
                    toggle={toggleDropdownSample}
                  >
                    <DropdownToggle
                      caret
                      className="buttonOrangeDefaultColor2"
                      size="sm"
                    >
                      Upload{" "}
                      <i className="mdi mdi-upload custom-btn-fs fs-6"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        className="dropdown-hover-item"
                        onClick={sampleExcel}
                      >
                        Sample CSV
                      </DropdownItem>
                      <DropdownItem
                        onClick={(e) => UploadBulkModal(true)}
                        className="dropdown-hover-item"
                      >
                        Upload CSV
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown> */}
                  <Dropdown
                    isOpen={dropdownOpenUpload}
                    toggle={toggleDropdownUpload}
                  >
                    <DropdownToggle
                      caret
                      className="buttonGreenDefaultColor"
                      size="sm"
                    >
                      Downloads {showDownload ? <Spinner size="sm" /> : ""}
                      <i className="mdi mdi-download custom-btn-fs fs-6"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={downloadExcel}
                        className="dropdown-hover-item"
                      >
                        Download CSV {showDownload ? <Spinner size="sm" /> : ""}
                      </DropdownItem>
                      <DropdownItem
                        onClick={(e) => setTemplateDownload(true)}
                        className="dropdown-hover-item"
                      >
                        Download Documents
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                

                  <Button
                    className="bg-transparent text-black"
                    style={{
                      border: "1px solid #829999",
                      color: "#343737",
                      marginTop: "0",
                    }}
                    size="sm"
                    onClick={ReloadApplication}
                  >
                    <FontAwesomeIcon icon={faRotateLeft} />
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody className="p-3">
              <>
                {selectedProduct === "Cattle" ? (
                  // <div className="p-1">
                  //   <CattleInsurance cattleDetails={users} />
                  // </div>
                  <div className="d-flex justify-content-end gap-2 mb-2">
                    <div></div>
                    <div
                      className={`chipTab ${
                        activeTab === "table" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("table")}
                    >
                      <FontAwesomeIcon icon={faTable} className="me-1" />
                      Table View
                    </div>
                    <div
                      className={`chipTab ${
                        activeTab === "map" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("map")}
                    >
                      <FontAwesomeIcon icon={faMapMarkedAlt} className="me-1" />
                      Map View
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {selectedProduct === "Cattle" && activeTab === "map" ? (
                  <div className="p-1">
                    <CattleInsurance cattleDetails={users} />
                  </div>
                ) : (
                  <div>
                    {!loadingLeads ? (
                      <>
                        <Box
                          className="mt-lg-0 mt-2"
                          sx={{
                            position: "relative",
                            ...(isLoading && { height: "50vh" }),
                          }}
                        >
                          <DataGrid
                            rows={users}
                            columns={filteredColumns}
                            initialState={{
                              pagination: {
                                paginationModel: {
                                  pageSize: 100,
                                },
                              },
                            }}
                            SelectionMode="Single"
                            SelectionUnit="Cell"
                            loading={isLoading || isFetching}
                            components={{
                              Pagination: CustomPagination,
                              NoRowsOverlay: CustomNoRowsOverlay,
                            }}
                          />
                        </Box>
                      </>
                    ) : (
                      <div className="text-center align-middle mt-5 pb-4">
                        {" "}
                        <Spinner
                          animation="border"
                          size="lg"
                          className="text-center align-middle"
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            </CardBody>
          </Card>
        </div>

        <Modal show={showLeadModal} onHide={hideLeadModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Add Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <div className="formdetails">
              <CrmAddLead
                setOpenLeadModal={setOpenLeadModal}
                refetch={refetch}
                selectedProduct={selectedProduct}
                isaddInsurer={false}
              />
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={editModel} onHide={hideLeadEditModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              Edit Lead
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <CrmEditLead
              leadDetails={leadDataEdit}
              refetch={refetch}
              LeadsDataGetId={leadDataEdit.allData}
              hideLeadEditModal={hideLeadEditModal}
              setCattleData={setCattleData}
              cattleData={cattleData}
              Isproposal={Isproposal}
              setIsProposal={setIsProposal}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={assignEmployeeModal}
          onHide={handleCloseAssignEmployeeModal}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Select Employee</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ padding: "1.5rem" }}>
            <CrmInsuranceAssignToEmployee
              setAssignEmployeeModal={setAssignEmployeeModal}
            />
          </Modal.Body>
        </Modal>
        <Modal show={audioModalOpen} onHide={closeaudioModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Audio Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-5">
            <CrmAudioDetails
              BankingApplicationId={BankingApplicationId}
              LeadsDataHalf={LeadsDataHalf}
            />
          </Modal.Body>
        </Modal>

        <Modal show={deleteModel} onHide={handleCloseDelete} size="md">
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "" }} className="fw-bold">
              Remove Lead
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="">
            <div className="">
              <h4 className="text-gray text-center mt-3">
                Are you Sure you Want to Remove{" "}
                <strong className="text-black">
                  {deleteLeadData.full_name}
                </strong>{" "}
                ?
              </h4>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-danger waves-effect me-2"
              onClick={handleCloseDelete}
            >
              Cancel
            </button>
            <button
              className="btn btn-success waves-effect me-2"
              onClick={() => SubmitdeleteLead()}
            >
              Remove &nbsp;
              {deleteModelSpinner ? (
                <Spinner animation="border" size="sm" />
              ) : (
                ""
              )}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={details}
          onHide={() => {
            setDetailsModal(false);
            EditingIsOpen(false);
          }}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title
              as="div"
              className="fw-bold d-flex justify-content-between align-items-center"
              style={{ width: "100%" }}
            >
              <span style={{ color: "#343737" }}>Lead Information</span>
              {/* <Button
                className="bg-transparent text-black"
                style={{
                  border: "1px solid #829999",
                  color: "#343737",
                }}
                size="sm"
                onClick={ReloadApplication2}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </Button> */}
              {selectedProduct === "Cattle" ? (
                <div>
                  {!(
                    LeadsDataHalf?.status_list?.includes("Policy Issued") ||
                    LeadsDataHalf?.status_list?.includes("Policy Rejected")
                  ) && !editOpen ? (
                    <Button
                      className="buttonOrangeDefaultColor mx-3 p-2"
                      size="sm"
                      onClick={() => handleEditLeads(LeadsDataHalf)}
                    >
                      Edit Lead
                    </Button>
                  ) : (
                    editOpen && (
                      <Button
                        className="btn btn-danger waves-effect me-2"
                        size="sm"
                        // onClick={hideLeadEditModal}
                        onClick={() => {
                          hideLeadEditModal();
                          ReloadApplication2();
                        }}
                      >
                        Cancel
                      </Button>
                    )
                  )}

                  {!editOpen && (
                    <Button
                      className="bg-transparent text-black"
                      style={{
                        border: "1px solid #829999",
                        color: "#343737",
                      }}
                      size="sm"
                      onClick={ReloadApplication2}
                    >
                      <FontAwesomeIcon icon={faRotateLeft} />
                    </Button>
                  )}
                </div>
              ) : (
                <Button
                  className="bg-transparent text-black"
                  style={{
                    border: "1px solid #829999",
                    color: "#343737",
                  }}
                  size="sm"
                  onClick={ReloadApplication2}
                >
                  <FontAwesomeIcon icon={faRotateLeft} />
                </Button>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ backgroundColor: "#f9f9f9" }}>
            {/* {loading ? (
              <Skeleton count={15} />
            ) : LeadsDataHalf ? (
              <InsuranceDetailViewModal
                serviceDetails={serviceDetails}
                LeadsDataHalf={LeadsDataHalf}
                selectedProduct={selectedProduct}
                refetchApplication={refetchLeadsData}
                refetch={refetch}
                setDetailsModal={setDetailsModal}
              />
            ) : (
              <p style={{ color: "#999", textAlign: "center" }}>
                No lead information available.
              </p>
            )} */}
            {editOpen ? (
              <div className="p-2">
                <CrmEditLead
                  leadDetails={leadDataEdit}
                  refetch={refetch}
                  LeadsDataGetId={leadDataEdit.allData}
                  hideLeadEditModal={hideLeadEditModal}
                  setCattleData={setCattleData}
                  cattleData={cattleData}
                  Isproposal={Isproposal}
                  setIsProposal={setIsProposal}
                  setDetailsModal={setDetailsModal}
                />
              </div>
            ) : (
              <div>
                {loading ? (
                  <Skeleton count={15} />
                ) : LeadsDataHalf ? (
                  <InsuranceDetailViewModal
                    serviceDetails={serviceDetails}
                    LeadsDataHalf={LeadsDataHalf}
                    selectedProduct={selectedProduct}
                    refetchApplication={refetchLeadsData}
                    refetch={refetch}
                    setDetailsModal={setDetailsModal}
                  />
                ) : (
                  <p style={{ color: "#999", textAlign: "center" }}>
                    No lead information available.
                  </p>
                )}
              </div>
            )}
          </Modal.Body>
        </Modal>
        <Modal show={assignAgency} onHide={handleCloseAssignModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Assign To Agency</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ padding: "1.5rem" }}>
            <InsuranceAssignAgency
              refetch={refetch}
              setAssignAgency={setAssignAgency}
            />
          </Modal.Body>
        </Modal>
        <Modal show={assignAgency} onHide={handleCloseAssignModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Update Status</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ padding: "1.5rem" }}>
            <InsuranceVerification
              refetch={refetch}
              handleCloseAssignEmployeeModal={handleCloseAssignModal}
            />
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
        <Modal show={assignDr} onHide={() => setAssignDr(false)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Assign To Agent</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ padding: "1.5rem" }}>
            <InsuranceAssignDr
              refetch={refetch}
              setAssignAgency={setAssignAgency}
              setAssignDr={setAssignDr}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={policyAssignModal}
          onHide={() => setPolicyModal(false)}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Policy Details</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "1.5rem" }}>
            <InsurancePolicyIssue
              refetch={refetch}
              setPolicyModal={setPolicyModal}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={templateDownload}
          onHide={() => setTemplateDownload(false)}
          size="xl"
        >
          <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
            <Modal.Title className="fw-bold">Download Report</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="mt-2 mx-2">
              <InsuranceTaskDownload />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
export default CrmInsurance;
